module.exports = __webpack_public_path__ + "img/paypal.13798983.svg";